import React from 'react';

import { Card, CardContent, CardHeader } from '@/shared/components/ui/Card';
import { Icon, type IconName } from '@/shared/icons';

/**
 * Seção de configuração no padrão do formulário de edição de canal
 * (`channels/components/sections/*`): Card com cabeçalho (ícone + título),
 * descrição curta e os campos UM ABAIXO DO OUTRO (`space-y-4`). Decisão do
 * dono 22/08: nada de legenda à esquerda e inputs à direita.
 */
export const SettingsSection: React.FC<{ icon: IconName; title: string; description: string; children: React.ReactNode; testId?: string }> = ({ icon, title, description, children, testId }) => (
  <Card data-testid={testId}>
    <CardHeader className="pb-3 px-4 py-3">
      <div className="flex items-center gap-2">
        <Icon name={icon} className="w-4 h-4" style={{ color: 'var(--theme-button-primary)' }} />
        <h3 className="font-bold text-[15px]" style={{ color: 'var(--theme-card-text)' }}>{title}</h3>
      </div>
    </CardHeader>
    <CardContent className="px-4 pb-4 space-y-4">
      <p className="text-xs" style={{ color: 'var(--theme-card-muted)' }}>{description}</p>
      {children}
    </CardContent>
  </Card>
);
SettingsSection.displayName = 'SettingsSection';
